<template>
<nav  class="sub-nav" :style="{top: top}">
	<router-link :to="{name:'blog',params:{category:'All'}}" active-class="active">
		All
	</router-link>
	<router-link v-for="category in categories" :key="category.id" :to="{ name: 'blog', params: { category: category.category } }" active-class="active">
		{{ category.category }}
	</router-link>
</nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {

	name: "SubNav",

	data(){
		return {
			topPx: 54,
			subNavOnly: false,
			navbarElement: null,
			ready:false,
		}
	},

	created(){
		window.addEventListener('scroll', this.handleScroll);


	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
		this.navbarElement.classList.remove("subnav-only");
		this.navbarElement.style.top = "0px";
	},

	mounted(){
		this.navbarElement = document.getElementById("navbar-main");

		var heightElement = document.getElementById("navbar-main-section");

		var smallHeightElement = document.getElementById("navbar-main-section-small");

		if(heightElement){
			this.topPx = heightElement.clientHeight+1;
		}

		if(smallHeightElement){
			if(smallHeightElement.clientHeight>this.topPx){
				this.topPx = smallHeightElement.clientHeight+1;
			}
		}
		//this.ready = true;
	},

	methods: {
		handleScroll(event) {


            var top = window.scrollY || window.scrollTop

            if(top>0){
				this.subNavOnly = true;
				this.navbarElement.classList.add("subnav-only");
				this.navbarElement.style.top = "-"+(this.topPx+1)+"px";
            } else {
            	this.subNavOnly = false;
             this.navbarElement.classList.remove("subnav-only");
				this.navbarElement.style.top = "0px";
            }
        },
	},

	computed: {
		top(){
			var result = this.topPx + 20 + "px";

			if(this.subNavOnly){
				result = "0px";
			}

			return result;
		},
		...mapGetters(["categories"]),
	},

};
</script>
